import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faAirbnb as fabAirbnb,
    faApple as fabApple,
    faAndroid as fabAndroid,
    faGooglePlay as fabGooglePlay,
    faPaypal as fabPaypal,
    faStripe as fabStripe,
} from '@fortawesome/free-brands-svg-icons';
import {
    faCalendarDays as farCalendarDays,
    faCircle as farCircle,
    faClone as farClone,
    faCreditCard as farCreditCard,
    faFilePdf as farFilePdf,
    faNoteSticky as farNoteSticky,
    faPaperPlane as farPaperPlane,
    faPenToSquare as farPenToSquare,
    faSquareCheck as farSquareCheck,
    faStar as farStar,
    faCircleXmark as farCircleXmark,
} from '@fortawesome/free-regular-svg-icons';
import {
    faAddressBook as fasAddressBook,
    faAddressCard as fasAddressCard,
    faAngleDown as fasAngleDown,
    faAngleDoubleDown as fasAngleDoubleDown,
    faAnglesLeft as fasAnglesLeft,
    faAnglesRight as fasAnglesRight,
    faAnglesUp as fasAnglesUp,
    faAngleUp as fasAngleUp,
    faArrowCircleDown as fasArrowCircleDown,
    faArrowDown as fasArrowDown,
    faArrowDownAZ as fasArrowDownAZ,
    faArrowDownShortWide as fasArrowDownShortWide,
    faArrowLeft as fasArrowLeft,
    faArrowRight as fasArrowRight,
    faArrowRotateLeft as fasArrowRotateLeft,
    faArrowRotateRight as fasArrowRotateRight,
    faArrowUp as fasArrowUp,
    faArrowsRotate as fasArrowsRotate,
    faAsterisk as fasAsterisk,
    faAt as fasAt,
    faBars as fasBars,
    faBath as fasBath,
    faBed as fasBed,
    faBell as fasBell,
    faBold as fasBold,
    faBoltLightning as fasBoltLightning,
    faBook as fasBook,
    faBookmark as fasBookmark,
    faBuilding as fasBuilding,
    faCalendarDays as fasCalendarDays,
    faCalendarXmark as fasCalendarXmark,
    faCar as fasCar,
    faCaretDown as fasCaretDown,
    faCaretRight as fasCaretRight,
    faCaretUp as fasCaretUp,
    faChartLine as fasChartLine,
    faChartPie as fasChartPie,
    faCheck as fasCheck,
    faCheckDouble as fasCheckDouble,
    faChevronDown as fasChevronDown,
    faChevronLeft as fasChevronLeft,
    faChevronRight as fasChevronRight,
    faChildReaching as fasChildReaching,
    faCircle as fasCircle,
    faCircleCheck as fasCircleCheck,
    faCircleChevronDown as fasCircleChevronDown,
    faCircleChevronRight as fasCircleChevronRight,
    faCircleChevronUp as fasCircleChevronUp,
    faCircleExclamation as fasCircleExclamation,
    faCircleInfo as fasCircleInfo,
    faCircleMinus as fasCircleMinus,
    faCirclePlus as fasCirclePlus,
    faCircleQuestion as fasCircleQuestion,
    faCircleUser as fasCircleUser,
    faCircleXmark as fasCircleXmark,
    faClock as fasClock,
    faClone as fasClone,
    faComments as fasComments,
    faCopy as fasCopy,
    faCreditCard as fasCreditCard,
    faCube as fasCube,
    faDog as fasDog,
    faDollarSign as fasDollarSign,
    faDownLeftAndUpRightToCenter as fasDownLeftAndUpRightToCenter,
    faDownload as fasDownload,
    faEarthAmericas as fasEarthAmericas,
    faEllipsisVertical as fasEllipsisVertical,
    faEnvelope as fasEnvelope,
    faEnvelopeOpenText as fasEnvelopeOpenText,
    faEye as fasEye,
    faEyeSlash as fasEyeSlash,
    faFile as fasFile,
    faFileCirclePlus as fasFileCirclePlus,
    faFileContract as fasFileContract,
    faFileExcel as fasFileExcel,
    faFileImage as fasFileImage,
    faFileInvoice as fasFileInvoice,
    faFileLines as fasFileLines,
    faFileSignature as fasFileSignature,
    faFilter as fasFilter,
    faFingerprint as fasFingerprint,
    faFloppyDisk as fasFloppyDisk,
    faGear as fasGear,
    faGears as fasGears,
    faGlobe as fasGlobe,
    faGripVertical as fasGripVertical,
    faHandHoldingDollar as fasHandHoldingDollar,
    faHandSparkles as fasHandSparkles,
    faHardDrive as fasHardDrive,
    faHotel as fasHotel,
    faHouseChimneyCrack as fasHouseChimneyCrack,
    faIdBadge as fasIdBadge,
    faIdCard as fasIdCard,
    faImage as fasImage,
    faImagePortrait as fasImagePortrait,
    faInbox as fasInbox,
    faKey as fasKey,
    faLanguage as fasLanguage,
    faLayerGroup as fasLayerGroup,
    faLink as fasLink,
    faList as fasList,
    faLocationDot as fasLocationDot,
    faLock as fasLock,
    faLockOpen as fasLockOpen,
    faMagnifyingGlass as fasMagnifyingGlass,
    faMapPin as fasMapPin,
    faMessage as fasMessage,
    faMicrochip as fasMicrochip,
    faMinus as fasMinus,
    faMobile as fasMobile,
    faMobileScreenButton as fasMobileScreenButton,
    faMoneyBill1 as fasMoneyBill1,
    faMoneyCheckDollar as fasMoneyCheckDollar,
    faNoteSticky as fasNoteSticky,
    faPaperPlane as fasPaperPlane,
    faPaperclip as fasPaperclip,
    faPenToSquare as fasPenToSquare,
    faPencil as fasPencil,
    faPercent as fasPercent,
    faPhone as fasPhone,
    faPhoneFlip as fasPhoneFlip,
    faPlane as fasPlane,
    faPlus as fasPlus,
    faPrint as fasPrint,
    faRecycle as fasRecycle,
    faPoll as fasPoll,
    faRightFromBracket as fasRightFromBracket,
    faRightLeft as fasRightLeft,
    faRightToBracket as fasRightToBracket,
    faRoad as fasRoad,
    faRotate as fasRotate,
    faReply as fasReply,
    faSort as fasSort,
    faScrewdriverWrench as fasScrewdriverWrench,
    faShower as fasShower,
    faSitemap as fasSitemap,
    faSliders as fasSliders,
    faSms as fasSms,
    faSpinner as fasSpinner,
    faStar as fasStar,
    faTag as fasTag,
    faToggleOff as fasToggleOff,
    faToggleOn as fasToggleOn,
    faTrash as fasTrash,
    faTriangleExclamation as fasTriangleExclamation,
    faUpRightAndDownLeftFromCenter as fasUpRightAndDownLeftFromCenter,
    faUpload as fasUpload,
    faUser as fasUser,
    faUserCheck as fasUserCheck,
    faUserClock as fasUserClock,
    faUserGear as fasUserGear,
    faUserShield as fasUserShield,
    faUserSlash as fasUserSlash,
    faUserTie as fasUserTie,
    faUserXmark as fasUserXmark,
    faUsers as fasUsers,
    faWallet as fasWallet,
    faWheelchair as fasWheelchair,
    faWifi as fasWifi,
    faXmark as fasXmark,
    faFolderOpen as fasFolderOpen,
    faFolderClosed as fasFolderClosed,
    faCarSide as fasCarSide,
    faSquareParking as fasSquareParking,
} from '@fortawesome/free-solid-svg-icons';

library.add(
    fabAirbnb,
    fabApple,
    fabAndroid,
    fabGooglePlay,
    fabPaypal,
    fabStripe,
    farCalendarDays,
    farCircle,
    farClone,
    farCreditCard,
    farFilePdf,
    farNoteSticky,
    farPaperPlane,
    farPenToSquare,
    farSquareCheck,
    farStar,
    farCircleXmark,
    fasAddressBook,
    fasAddressCard,
    fasAngleDown,
    fasAngleDoubleDown,
    fasAnglesLeft,
    fasAnglesRight,
    fasAnglesUp,
    fasAngleUp,
    fasArrowCircleDown,
    fasArrowDown,
    fasArrowDownAZ,
    fasArrowDownShortWide,
    fasArrowLeft,
    fasArrowRight,
    fasArrowRotateLeft,
    fasArrowRotateRight,
    fasArrowsRotate,
    fasArrowUp,
    fasAsterisk,
    fasAt,
    fasBars,
    fasBath,
    fasBed,
    fasBell,
    fasBold,
    fasBoltLightning,
    fasBook,
    fasBookmark,
    fasBuilding,
    fasCalendarDays,
    fasCalendarXmark,
    fasCar,
    fasCaretDown,
    fasCaretRight,
    fasCaretUp,
    fasChartLine,
    fasChartPie,
    fasCheck,
    fasCheckDouble,
    fasChevronDown,
    fasChevronLeft,
    fasChevronRight,
    fasChildReaching,
    fasCircle,
    fasCircleCheck,
    fasCircleChevronDown,
    fasCircleChevronRight,
    fasCircleChevronUp,
    fasCircleExclamation,
    fasCircleInfo,
    fasCircleMinus,
    fasCirclePlus,
    fasCircleQuestion,
    fasCircleUser,
    fasCircleXmark,
    fasClock,
    fasClone,
    fasComments,
    fasCopy,
    fasCreditCard,
    fasCube,
    fasDog,
    fasDollarSign,
    fasDownLeftAndUpRightToCenter,
    fasDownload,
    fasEarthAmericas,
    fasEllipsisVertical,
    fasEnvelope,
    fasEnvelopeOpenText,
    fasEye,
    fasEyeSlash,
    fasFile,
    fasFileCirclePlus,
    fasFileContract,
    fasFileExcel,
    fasFileImage,
    fasFileInvoice,
    fasFileLines,
    fasFileSignature,
    fasFilter,
    fasFingerprint,
    fasFloppyDisk,
    fasGear,
    fasGears,
    fasGlobe,
    fasGripVertical,
    fasHandHoldingDollar,
    fasHandSparkles,
    fasHardDrive,
    fasHotel,
    fasHouseChimneyCrack,
    fasIdBadge,
    fasIdCard,
    fasImage,
    fasImagePortrait,
    fasInbox,
    fasKey,
    fasLanguage,
    fasLayerGroup,
    fasLink,
    fasList,
    fasLocationDot,
    fasLock,
    fasLockOpen,
    fasMagnifyingGlass,
    fasMapPin,
    fasMessage,
    fasMicrochip,
    fasMinus,
    fasMobile,
    fasMobileScreenButton,
    fasMoneyBill1,
    fasMoneyCheckDollar,
    fasNoteSticky,
    fasPaperclip,
    fasPaperPlane,
    fasPencil,
    fasPenToSquare,
    fasPercent,
    fasPhone,
    fasPhoneFlip,
    fasPlane,
    fasPlus,
    fasPrint,
    fasPoll,
    fasRecycle,
    fasRightFromBracket,
    fasRightLeft,
    fasRightToBracket,
    fasRoad,
    fasRotate,
    fasReply,
    fasSort,
    fasScrewdriverWrench,
    fasShower,
    fasSitemap,
    fasSliders,
    fasSms,
    fasSpinner,
    fasStar,
    fasTag,
    fasToggleOff,
    fasToggleOn,
    fasTrash,
    fasTriangleExclamation,
    fasUpload,
    fasUpRightAndDownLeftFromCenter,
    fasUser,
    fasUserCheck,
    fasUserClock,
    fasUserGear,
    fasUsers,
    fasUserShield,
    fasUserSlash,
    fasUserTie,
    fasUserXmark,
    fasWallet,
    fasWheelchair,
    fasWifi,
    fasXmark,
    fasFolderOpen,
    fasFolderClosed,
    fasCarSide,
    fasSquareParking,
);